import { Box } from "@mui/material";
import { PageTitle } from "../../misc/PageTitle";
import { ResponsiveHashTabs } from "../../misc/ResponsiveHashTabs";
import { overviewCardStyle } from "../../misc/backofficeTheme";
import { DrivingSchoolCoursesCalendar } from "./DrivingSchoolCoursesCalendar";
import { DrivingSchoolCoursesList } from "./DrivingSchoolCoursesList";

export function DrivingSchoolCourses() {
  const tabs = [
    {
      value: "",
      label: "Kalender",
      content: (
        <Box sx={{ ...overviewCardStyle, borderTopLeftRadius: { xs: "16px", sm: 0 }, p: 3, mt: 0 }}>
          <DrivingSchoolCoursesCalendar />
        </Box>
      ),
    },
    {
      value: "list",
      label: "Liste",
      content: <DrivingSchoolCoursesList />,
    },
  ];

  return (
    <div>
      <PageTitle>Kurse</PageTitle>
      <ResponsiveHashTabs tabs={tabs} mobileSelectAriaLabel="Kurse-Ansicht" />
    </div>
  );
}
